$.fn.extend({
	/**
	 * jQuery extension which scrolls to a given element
	 *
	 * @author Boye Oomens <boye@e-sites.nl>
	 * @param {Number} speed - in miliseconds
	 * @param {Number} offset - y-axis in pixels
	 * @param {String} easing - type of easing (swing or linear)
	 * @return {Object}
	 */
	scrollTo: function (config) {
		var defaults = {
			scrollContainer: 'html, body',
			speed: null,
			offset: 50,
			easing: null
		};
		var settings = $.extend({}, defaults, config);

		return this.each(function () {
			$(settings.scrollContainer).animate({scrollTop: ($(this).offset().top - settings.offset)}, settings.speed, settings.easing);
		});
	}
});